<div [formGroup]="parentGroup">
  <mat-form-field appearance="fill"
    [ngClass]="{'invisible':formElement.hidden === 'true'}">
    <mat-label>
      {{ formElement.text }}
    </mat-label>
  
    <input matInput [matDatepicker]="picker" [formControlName]="formElement.formControl">
    <span fxLayout="row" matSuffix>
      <mat-datepicker-toggle [for]="picker"></mat-datepicker-toggle>
    </span>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
</div>
